import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const EventIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "EventIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.92071 10.4817C3.53382 10.78 3.47805 10.9878 3.47805 11.0776C3.47805 11.1674 3.53382 11.3752 3.92071 11.6735C4.29747 11.964 4.88846 12.2571 5.68411 12.5166C7.26739 13.0329 9.5006 13.3643 12.0003 13.3643C14.5001 13.3643 16.7333 13.0329 18.3166 12.5166C19.1122 12.2571 19.7032 11.964 20.08 11.6735C20.4669 11.3752 20.5226 11.1674 20.5226 11.0776C20.5226 10.9878 20.4669 10.78 20.08 10.4817C19.7032 10.1912 19.1122 9.89805 18.3166 9.6386C16.7333 9.12232 14.5001 8.79088 12.0003 8.79088C9.5006 8.79088 7.26739 9.12232 5.68411 9.6386C4.88846 9.89805 4.29747 10.1912 3.92071 10.4817ZM5.23118 8.24963C6.99675 7.6739 9.38992 7.32992 12.0003 7.32992C14.6108 7.32992 17.0039 7.6739 18.7695 8.24963C19.6483 8.53618 20.4123 8.89318 20.972 9.32466C21.5215 9.74833 21.9836 10.3343 21.9836 11.0776C21.9836 11.8209 21.5215 12.4069 20.972 12.8305C20.4123 13.262 19.6483 13.619 18.7695 13.9056C17.0039 14.4813 14.6108 14.8253 12.0003 14.8253C9.38992 14.8253 6.99675 14.4813 5.23118 13.9056C4.35241 13.619 3.58835 13.262 3.02869 12.8305C2.47915 12.4069 2.01709 11.8209 2.01709 11.0776C2.01709 10.3343 2.47915 9.74833 3.02869 9.32466C3.58836 8.89318 4.35241 8.53618 5.23118 8.24963Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.30842 13.2366C6.25902 13.592 5.95393 13.8656 5.58494 13.8656C5.18151 13.8656 4.85446 13.5386 4.85446 13.1351C4.85446 12.4988 5.34442 12.0939 5.71168 11.8723C6.12365 11.6237 6.67115 11.4257 7.28331 11.2695C8.51872 10.9542 10.1861 10.7672 12.0003 10.7672C13.8146 10.7672 15.482 10.9542 16.7174 11.2695C17.3295 11.4257 17.877 11.6237 18.289 11.8723C18.6563 12.0939 19.1462 12.4988 19.1462 13.1351C19.1462 13.5386 18.8192 13.8656 18.4157 13.8656C18.0468 13.8656 17.7417 13.592 17.6923 13.2366C17.6676 13.2134 17.62 13.175 17.5342 13.1232C17.2969 12.98 16.9049 12.8251 16.3561 12.6851C15.2696 12.4077 13.7293 12.2281 12.0003 12.2281C10.2714 12.2281 8.73113 12.4077 7.64462 12.6851C7.09583 12.8251 6.70381 12.98 6.46651 13.1232C6.38067 13.175 6.33308 13.2134 6.30842 13.2366Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.74757 10.3471C3.151 10.3471 3.47805 10.6742 3.47805 11.0776V18.2518C3.47805 18.3417 3.53382 18.5495 3.92071 18.8477C4.29747 19.1382 4.88846 19.4314 5.68411 19.6908C7.26739 20.2071 9.5006 20.5386 12.0003 20.5386C14.5001 20.5386 16.7333 20.2071 18.3166 19.6908C19.1122 19.4314 19.7032 19.1382 20.08 18.8477C20.4669 18.5495 20.5226 18.3417 20.5226 18.2518V11.0776C20.5226 10.6742 20.8497 10.3471 21.2531 10.3471C21.6565 10.3471 21.9836 10.6742 21.9836 11.0776V18.2518C21.9836 18.9952 21.5215 19.5811 20.972 20.0048C20.4123 20.4363 19.6483 20.7932 18.7695 21.0798C17.0039 21.6555 14.6108 21.9995 12.0003 21.9995C9.38992 21.9995 6.99674 21.6555 5.23118 21.0798C4.3524 20.7932 3.58835 20.4362 3.02869 20.0048C2.47915 19.5811 2.01709 18.9952 2.01709 18.2518V11.0776C2.01709 10.6742 2.34414 10.3471 2.74757 10.3471Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.53282 16.8319C8.53282 16.4284 8.85987 16.1014 9.2633 16.1014H14.6943C15.0977 16.1014 15.4248 16.4284 15.4248 16.8319V20.8548C15.4248 21.2582 15.0977 21.5853 14.6943 21.5853C14.2908 21.5853 13.9638 21.2582 13.9638 20.8548V17.5623H9.99378V20.8548C9.99378 21.2582 9.66673 21.5853 9.2633 21.5853C8.85987 21.5853 8.53282 21.2582 8.53282 20.8548V16.8319Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0003 16.1712C12.4038 16.1712 12.7308 16.4982 12.7308 16.9017V21.269C12.7308 21.6725 12.4038 21.9995 12.0003 21.9995C11.5969 21.9995 11.2699 21.6725 11.2699 21.269V16.9017C11.2699 16.4982 11.5969 16.1712 12.0003 16.1712Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.74757 14.5606C3.151 14.5606 3.47805 14.8877 3.47805 15.2911C3.47805 15.3645 3.51177 15.5109 3.73679 15.7291C3.96351 15.9489 4.33287 16.1874 4.85977 16.4189C5.90967 16.8801 7.43815 17.2499 9.25985 17.4395C9.66111 17.4812 9.95255 17.8404 9.91079 18.2416C9.86903 18.6429 9.50989 18.9343 9.10862 18.8926C7.19718 18.6936 5.50733 18.299 4.27218 17.7565C3.65656 17.486 3.11672 17.1628 2.71986 16.778C2.32132 16.3917 2.01709 15.8908 2.01709 15.2911C2.01709 14.8877 2.34414 14.5606 2.74757 14.5606Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2531 14.5606C21.6565 14.5606 21.9836 14.8877 21.9836 15.2911C21.9836 15.8974 21.6728 16.4024 21.2676 16.7908C20.8638 17.1778 20.3144 17.5028 19.6876 17.7743C18.4299 18.3191 16.7096 18.7128 14.7663 18.9053C14.3648 18.9451 14.0071 18.6519 13.9674 18.2504C13.9276 17.849 14.2208 17.4913 14.6223 17.4515C16.4751 17.2679 18.0343 16.8983 19.1069 16.4337C19.6453 16.2005 20.0239 15.9592 20.2567 15.7361C20.4881 15.5142 20.5226 15.3652 20.5226 15.2911C20.5226 14.8877 20.8497 14.5606 21.2531 14.5606Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.09032 2.72999C6.09032 2.32656 6.41736 1.99951 6.8208 1.99951H17.1799C17.5833 1.99951 17.9104 2.32656 17.9104 2.72999V5.84777C17.9104 6.2512 17.5833 6.57825 17.1799 6.57825H6.8208C6.41736 6.57825 6.09032 6.2512 6.09032 5.84777V2.72999ZM7.55128 3.46047V5.11729H16.4494V3.46047H7.55128Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.53055 5.1173C8.93398 5.1173 9.26103 5.44435 9.26103 5.84778V8.0604C9.26103 8.46383 8.93398 8.79088 8.53055 8.79088C8.12712 8.79088 7.80007 8.46383 7.80007 8.0604V5.84778C7.80007 5.44435 8.12712 5.1173 8.53055 5.1173Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4701 5.1173C15.8736 5.1173 16.2006 5.44435 16.2006 5.84778V8.0604C16.2006 8.46383 15.8736 8.79088 15.4701 8.79088C15.0667 8.79088 14.7397 8.46383 14.7397 8.0604V5.84778C14.7397 5.44435 15.0667 5.1173 15.4701 5.1173Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0003 9.34694C12.4038 9.34694 12.7308 9.67399 12.7308 10.0774V11.4977C12.7308 11.9011 12.4038 12.2281 12.0003 12.2281C11.5969 12.2281 11.2699 11.9011 11.2699 11.4977V10.0774C11.2699 9.67399 11.5969 9.34694 12.0003 9.34694Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.69934 9.49042C9.08774 9.3813 9.49106 9.60769 9.60018 9.99609L9.96655 11.3001C10.0757 11.6885 9.84928 12.0918 9.46089 12.2009C9.07249 12.31 8.66917 12.0836 8.56005 11.6953L8.19368 10.3913C8.08456 10.0029 8.31095 9.59954 8.69934 9.49042Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2582 9.49042C15.6466 9.59955 15.873 10.0029 15.7639 10.3913L15.3975 11.6953C15.2884 12.0837 14.8851 12.31 14.4967 12.2009C14.1083 12.0918 13.8819 11.6885 13.991 11.3001L14.3574 9.99608C14.4665 9.60769 14.8699 9.3813 15.2582 9.49042Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default EventIcon;
